export default __webpack_public_path__ + "src/images/packages/villa-mangata/d606fdfe8c0742205992048ba08af529-5.jpg";